import cx from 'classnames'

import { ReactComponent as CloseIconMd } from 'assets/icons/close24.svg'
import { ReactComponent as CloseIconSm } from 'assets/icons/close16.svg'
import Styles from './CloseButton.module.scss'

interface Props {
  className?: string
  onClick: () => void
  size?: 'sm' | 'md'
  color?: 'gray' | 'black' | 'blue-50'
}

export const CloseButton = ({ onClick, className, size = 'md', color = 'black' }: Props) => {
  return (
    <button className={cx(Styles.root, Styles[color], className)} onClick={onClick} aria-label="Close">
      {size === 'sm' && <CloseIconSm />}
      {size === 'md' && <CloseIconMd />}
    </button>
  )
}
